module.exports = __webpack_public_path__ + "img/chongzhou1.00094330.png";